export default __webpack_public_path__ + "moin-logo-splash.79dbe70be203641dac0e538b4fff9bda.png";